import { useAuthStore, personaFor } from '@/entities/session';
import { TodayPage } from '@/pages/today/TodayPage';
import { FamilyDashboardPage } from '@/pages/family-dashboard/FamilyDashboardPage';

/**
 * Persona home (FSD `pages`). A kid lands on their day (today's chores); a guardian lands on the
 * family dashboard. Both are the index route under the persona shell.
 */
export function HomePage(): React.ReactElement {
  const user = useAuthStore((s) => s.user);
  if (user && personaFor(user) === 'kid') {
    return <TodayPage />;
  }
  return <FamilyDashboardPage />;
}
